import { Component, Input, OnInit } from '@angular/core';
import { FrequencyProvider } from "../../shared/providers/frequency.provider";
import { RolesProvider } from "../../shared/providers/roles.provider";
import { ChannelProvider } from "../../shared/providers/channel.provider";
import { RegionProvider } from "../../shared/providers/region.provider";
import { AdminDataProvider } from "../../shared/providers/master-provider/admin-data.provider";
import { ApiService } from 'src/app/services/http/api.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateFormateService } from "../../../services/date-formate.service";

@Component({
  selector: 'app-view-single-scheme',
  templateUrl: './view-single-scheme.component.html',
  styleUrls: ['./view-single-scheme.component.scss']
})
export class ViewSingleSchemeComponent implements OnInit {

  receivedData: any = {};
  selectedScheme: String;
  selectedBasedOn: String;
  selectedAllocationType: String;
  selectedRewardType: String;
  selectedMetricesType: String;
  growthAndPortfolioArray: any = [{}];
  rewardData: any = {};
  filterParams;
  filteredDetails: any = { regions: [], outlets: [] };

  users: any = [];

  selectedUsers: any = [];
  selectAll: Boolean = true;
  finalUserList: any = [];
  term;
  categoryName: string;

  formData: any = {
    scheme_name: '',
    program_id: 1,
    campaign_id: 2,
    user_type: 5,
    tier: "",
    regions: "",
    outlets: [],
    channel_type: 5,
    scheme_type: "",
    based_on: "",
    reward_data: ""
  }

  detailsFormData: any = {
    s_no: 1,
    basedOn: '',
    sku_name: '',
    categoryName: '',
    condition_value: '',
    condition_unit: '',
    metric: '',
    growth_value: '',
    growth_unit: '',
    points: "",
  };

  t1Array: any = [this.detailsFormData];
  t2Array: any = [this.detailsFormData];

  schemeTypes = [
    {
      id: 1,
      name: 'Value'
    },
    {
      id: 2,
      name: 'Volume'
    },
    {
      id: 3,
      name: 'Focus SKU'
    },
    {
      id: 4,
      name: 'Growth%'
    },
    {
      id: 5,
      name: 'Portfolio'
    },
    {
      id: 15,
      name: 'QR Based'

    }
  ]

  basedOnTypes = [
    {
      id: 1,
      name: 'SKU'
    },
    {
      id: 2,
      name: 'Category'
    }
  ]

  tier = [
    {
      id: 1,
      name: 'Silver'
    },
    {
      id: 2,
      name: 'Gold'
    }
  ]

  pointsAllocationTypes = [
    {
      id: 1,
      name: 'Individual'
    },
    {
      id: 2,
      name: 'Combined'
    }
  ]

  rewardTypes = [
    {
      id: 1,
      name: 'Percentage'
    },
    {
      id: 2,
      name: 'Points'
    },
    {
      id: 3,
      name: 'Fixed Points'
    },
    {
      id: 16,
      name: 'Referral'
    },

  ];

  metricesTypes = [
    {
      id: 1,
      name: 'Value'
    },
    {
      id: 2,
      name: 'Volume'
    }
  ]

  productList: any = [];

  categoryList: any = [];

  roles: any = [];
  channels: any = [];
  regions: any = [];
  fequencyList: any = [];
  id: any;
  today;
  bindSelectedRegions: any = [];
  disabled: boolean = true;


  constructor(
    public frequencyProvider: FrequencyProvider,
    public rolesProvider: RolesProvider,
    public channelProvider: ChannelProvider,
    public regionProvider: RegionProvider,
    public adminDataProvider: AdminDataProvider,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private formateDate: DateFormateService
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id')
  }

  ngOnInit() {
    this.getProductList();
    //this.getProductCategories();
    this.getScheme();

  }

  ngDoCheck() {
    this.fequencyList = this.frequencyProvider.frequency;
    this.roles = this.rolesProvider.roles;
    this.channels = this.channelProvider.channels;
    this.regions = this.regionProvider.regions;
  }

  getScheme() {
    this.apiService.get(this.apiConfig.getSchemes + '?id=' + this.id)
      .subscribe((res: any) => {
        this.receivedData = res.data
        //
        //initial parameters
        this.rewardData = this.receivedData.reward_data;

        this.formData.from = this.receivedData.reward_data.period_start;
        this.formData.to = this.receivedData.reward_data.period_end;
        this.formData.scheme_name = this.receivedData.scheme_name;
        this.formData.scheme_type = this.receivedData.scheme_type;
        this.formData.based_on = this.receivedData.based_on
        this.selectedScheme = this.receivedData.scheme_type;
        this.selectedBasedOn = this.receivedData.based_on;
        this.selectedRewardType = this.rewardData.reward_type;
        this.formData.tier = this.receivedData.tier;
        this.t1Array = this.receivedData.reward_data.sku_details;
        this.users = this.receivedData.outlets_details;

        this.selectedAllocationType = this.rewardData.points_allocation;
        this.t1Array = this.receivedData.reward_data.sku_details;
        this.t2Array = this.receivedData.reward_data.sku_details;

        //this.mapOutlets();
        if (this.receivedData.regions) {
          this.receivedData.regions.forEach(element => {
            this.bindSelectedRegions.push({ id: element });
          });
        }

      }, err => {
        
      });
  }

  getProductList() {
    this.apiService.get(this.apiConfig.getSchemeProductCategory)
      .subscribe((res: any) => {
        this.productList = res.data.product_details;
        this.categoryList = res.data.ecommerce_categories;
      }, err => {
        this.toast.Error('Error getting products');
      })
  }

  getProductCategories() {
    this.apiService.get(this.apiConfig.getProductCategories)
      .subscribe((res: any) => {
        this.categoryList = res.data.ecommerce_categories;

      }, err => {
        this.toast.Error('Error getting products');
      })
  }

  basedOnSelected(basedOn) {
    this.selectedBasedOn = basedOn;
  }

  allocationTypeSelected(allocation) {
    this.selectedAllocationType = allocation;
  }

  rewardTypeSelected(reward) {
    this.selectedRewardType = reward;
  }

  basedOnMetrices(metrices, i) {
    this.selectedMetricesType = metrices;
    this.t1Array[i].metric = metrices;
  }

  //Table 1 selected values
  t1ProductSelected(value, i) {
    this.t1Array[i].sku_name = value;

  }

  t1CategorySelected(value, i) {
    this.t1Array[i].categoryName = value;
  }

  t1ConditionValue(value, i) {
    this.t1Array[i].condition_value = value;
  }

  t1ConditionUnit(value, i) {
    this.t1Array[i].condition_unit = value;
  }

  t1Points(value, i) {
    this.t1Array[i].points = value;
  }

  //TABLE 2, i.e growth% and Portfolio

  t2AddNewInput() {
    this.growthAndPortfolioArray.push({});
    this.t2Array.push(JSON.parse(JSON.stringify(this.detailsFormData)));
    var changeSlNo = this.t2Array.length;
    this.t2Array[changeSlNo - 1].s_no = changeSlNo;
  }

  t2ProductSelected(value, i) {
    this.t2Array[i].sku_name = value;
  }

  t2CategorySelected(value, i) {
    this.t2Array[i].categoryName = value;
  }

  t2BasedOnSelected(value, i) {
    this.growthAndPortfolioArray[i].name = value;
    this.t2Array[i].basedOn = value;
  }

  t2ConditionValue(value, i) {
    this.t2Array[i].condition_value = value;
  }

  t2ConditionUnit(value, i) {
    this.t2Array[i].condition_unit = value;
  }

  t2MetricesSelected(value, i) {
    this.growthAndPortfolioArray[i].metrices = value;
    this.t2Array[i].metric = value;
  }

  t2Points(value, i) {
    this.t2Array[i].points = value;
  }

  t2GrowthValue(value, i) {
    this.t2Array[i].growth_value = value;
  }

  t2PointsPerUnit(value, i) {
    this.t2Array[i].scheme_point = value;
  }

  t2GrowthUnit(value, i) {
    this.t2Array[i].growth_unit = value;
  }

  /** User Assignment section */
  /* Fillter section start */

  formateFillters(data, name) {
    if (data.status == "singleSelect") {
      this.filteredDetails[name].push(data.data.id);
      return this.filteredDetails[name];
    } else if (data.status == "singleDeselect") {
      this.filteredDetails[name].forEach((element, i) => {
        if (element == data.data.id) {
          this.filteredDetails[name].splice(i, 1)
        }
      });
      return this.filteredDetails[name];
    } else if (data.status == "SelectAll") {
      this.filteredDetails[name] = [];
      if (data.data) {
        data.data.forEach(element => {
          this.filteredDetails[name].push(element.id);
        });
      }
      return this.filteredDetails[name];
    } else if (data.status == "unSelectAll") {
      this.filteredDetails[name] = [];
      return this.filteredDetails[name];
    }
  }

  // checkRequiredFieldsAndSubmit() {
  //  // this.getSelectedUsers();
  //   this.formData.scheme_type = this.selectedScheme;
  //   this.formData.based_on = this.selectedBasedOn;

  //   if (this.filteredDetails.outlets.length == 0) {
  //     this.toast.Error('Select Outlets');
  //     return
  //   } else {
  //     this.formData.outlets = this.filteredDetails.outlets
  //     this.formData.regions = this.filteredDetails.regions
  //   }

  //   if (this.formData.scheme_type == '1' || this.formData.scheme_type == '2' || this.formData.scheme_type == '3') {
  //     this.t1Array.forEach((t1, i) => {
  //       
  //       if (t1.condition_value == '') {
  //         this.toast.Error(`Missing Values in for condition ${t1.s_no}.`)
  //         return
  //       }
  //     });
  //   }

  //   if (this.formData.scheme_type == '4' || this.formData.scheme_type == '5') {
  //     this.t2Array.forEach((t2, i) => {
  //       
  //       if (t2.basedOn == '' || t2.metric == '') {
  //         this.toast.Error(`Missing Values in for condition ${t2.s_no}.`)
  //         return
  //       }
  //     });
  //   }

  //   if (this.formData.scheme_name == undefined || this.rewardData.scheme_detail_desc == undefined || this.rewardData.scheme_detail_name == undefined || this.rewardData.scheme_detail_eligibility == undefined || this.rewardData.scheme_detail_tnc == undefined) {
  //     this.toast.Error("Fill All Scheme detail fields")
  //     return
  //   }

  //   this.onSubmitConfigurations()

  // }

  // onSubmitConfigurations() {

  //   if (this.formData.scheme_type == '1' || this.formData.scheme_type == '2' || this.formData.scheme_type == '3') {
  //     this.rewardData.sku_details = this.t1Array;
  //   } else {
  //     this.rewardData.sku_details = this.t2Array;
  //   }

  //   this.rewardData.reward_type = this.selectedRewardType;
  //   this.rewardData.points_allocation = this.selectedAllocationType;
  //   this.formData.reward_data = this.rewardData
  //   
  //   // return 
  //   this.apiService.put(this.apiConfig.updateScheme + this.id, this.formData)
  //     .subscribe((res: any) => {
  //       this.toast.Success('Scheme configured Successfully');
  //       this.router.navigateByUrl('/hubAdmin/schemes-list')
  //     })
  // }
}
